import React, { useState } from "react";
import CardLayout from "../../common/cardLayout/CardLayout";
import {
  PatientFAQ,
  ProviderFAQ,
  dummyAccordionData,
} from "../../../constants/dummyData";
import {
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from "@coreui/react";

const Tab = ({ text, isActive = false }) => {
  return (
    <div
      style={{
        userSelect: "none",
        cursor: "pointer",
        padding: "20px 30px",
        backgroundColor: isActive ? "#51B6F5" : "#f1f1f5",
        color: isActive ? "white" : "#667085",
        fontWeight: "400",
        fontSize: "0.9rem",
      }}
    >
      {text}
    </div>
  );
};

const AccordionItem = ({ id, heading, data }) => {
  return (
    <CAccordionItem itemKey={id}>
      <CAccordionHeader>{heading}</CAccordionHeader>
      {data?.map((item, index) => {
        return (
          <CAccordionBody className="p-4" key={id + index}>
            <div className="container-fluid d-flex">
              <h5
                className="primary-text"
                style={{ fontSize: "1vw", textAlign: "start" }}
              >
                {item?.title}
              </h5>
            </div>
            <div
              dangerouslySetInnerHTML={{ __html: item?.text }}
              className="accordion-body"
              style={{ userSelect: "none" }}
            ></div>
          </CAccordionBody>
        );
      })}
    </CAccordionItem>
  );
};
const AccordionComponent = ({ accordionData }) => {
  return (
    <CAccordion>
      {accordionData?.map((item) => {
        return (
          <AccordionItem
            key={item.id}
            id={item.id}
            heading={item?.heading}
            data={item?.data}
          />
        );
      })}
    </CAccordion>
  );
};

const InternalSwitcher = () => {
  const [currentComponent, setCurrentComponent] = useState(1);
  return (
    <div className="container-fluid mb-2">
      <div className="d-flex w-100" style={{ gap: "0px", margin: "0px" }}>
        <div
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentComponent(1);
          }}
        >
          <Tab text={"Provider FAQs"} isActive={currentComponent === 1} />
        </div>
        <div
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentComponent(2);
          }}
        >
          <Tab text={"Patient FAQs"} isActive={currentComponent === 2} />
        </div>
      </div>
      {currentComponent === 1 ? (
        <AccordionComponent accordionData={ProviderFAQ} />
      ) : (
        <AccordionComponent accordionData={PatientFAQ} />
      )}
    </div>
  );
};

const FAQ = () => {
  return (
    <CardLayout>
      <div className="container-fluid d-flex justify-content-start w-100 py-3">
        <h5 className="muted-text">Frequently Asked Questions</h5>
      </div>
      <div className="container-fluid py-2">
        <InternalSwitcher />
      </div>
    </CardLayout>
  );
};

export default FAQ;
